
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitokhandalacab() {



    const cardData =
    {
        keyword: ' Mumbai to Khandala Cab    ',
        heading: 'Deva Cabs: Mumbai to Khandala Cab   ',
        headingDescription: 'Deva Cabs offers reliable and comfortable cab services from Mumbai to Khandala, perfect for short trips, weekend escapes, and nature getaways. Located around 80 km from Mumbai, Khandala is a serene hill station, and our cabs ensure a smooth and enjoyable ride through scenic routes. Choose from a range of vehicles—Sedans, SUVs, or Innova Crysta—driven by experienced chauffeurs. With transparent pricing, flexible pickup timings, and 24/7 service, Deva Cabs makes your Mumbai to Khandala journey stress-free and delightful.',

        top: 'Top Places to Visit in Khandala with Deva Cabs',

"topPlaces": [
  {
    "title": "Rajmachi Point",
    "location": "Khandala, Maharashtra",
    "description": "Rajmachi Point is a famous viewpoint in Khandala that offers spectacular views of the Rajmachi Fort and the surrounding valleys. Located on the Mumbai-Pune Expressway, it is an ideal stopover for travelers seeking a quick but stunning photo opportunity and a refreshing view of the Western Ghats."
  },
  {
    "title": "Duke’s Nose",
    "location": "Khandala, Maharashtra",
    "description": "Duke’s Nose is a cliff shaped like a nose, named after the Duke of Wellington. It's a popular spot for trekking, rock climbing, and rappelling. The viewpoint offers panoramic vistas of lush valleys and deep gorges, especially mesmerizing during sunrise and monsoon mist."
  },
  {
    "title": "Kune Falls",
    "location": "Khandala, Maharashtra",
    "description": "Kune Falls is a three-tiered waterfall nestled amidst the Sahyadri hills and is one of the highest waterfalls in Maharashtra. Cascading from a height of 200 meters, it’s a picturesque destination perfect for nature photography, monsoon visits, and peaceful relaxation."
  },
  {
    "title": "Tiger’s Leap",
    "location": "Khandala, Maharashtra",
    "description": "Tiger’s Leap, also accessible from Lonavala, is a dramatic cliff-top offering thrilling views of the valley below. The name comes from its resemblance to a leaping tiger. It features an echo point and becomes especially scenic during the monsoon, with waterfalls nearby."
  },
  {
    "title": "Amrutanjan Point",
    "location": "Khandala, Maharashtra",
    "description": "Amrutanjan Point is a lesser-known but beautiful viewpoint at the beginning of the Khandala Ghat. Surrounded by forested hills, it’s a quiet stop with fewer crowds and breathtaking views of the deep valley and winding roads below—ideal for photography and peaceful moments."
  },
  {
    "title": "Bhushi Lake",
    "location": "Near Khandala, Maharashtra",
    "description": "Bhushi Lake is formed by the Bhushi Dam and offers a serene environment with flowing streams and rocky outcrops. Although more famous in nearby Lonavala, it’s equally accessible from Khandala and draws visitors for its scenic monsoon beauty and casual waterside fun."
  },
  {
    "title": "Lohagad Fort",
    "location": "Near Khandala, Maharashtra",
    "description": "Lohagad Fort is a popular monsoon trekking destination near Khandala. The fort boasts historical Maratha architecture and offers views of the Pavana Dam and surrounding mountains. The lush green trail and ancient steps provide a perfect mix of adventure and heritage."
  },
  {
    "title": "Karla and Bhaja Caves",
    "location": "Near Khandala, Maharashtra",
    "description": "These ancient Buddhist rock-cut caves are located close to Khandala and are over 2,000 years old. Featuring intricate carvings, stupas, and prayer halls, the caves are significant both archaeologically and spiritually. They offer a serene and historical trekking experience."
  },
  {
    "title": "Ryewood Park",
    "location": "Near Khandala, Maharashtra",
    "description": "Ryewood Park is a spacious and well-maintained garden near Khandala that’s ideal for families and picnickers. It features tall trees, flowerbeds, and plenty of shade. The calm ambiance and accessibility make it a great place for morning walks or relaxed afternoons."
  },
  {
    "title": "Monkey Hill",
    "location": "Khandala, Maharashtra",
    "description": "Monkey Hill is a fun and scenic stop on the route to Khandala, known for the monkeys that freely roam the area and the stunning views of the valley. It’s a nice detour for travelers driving through the ghat, offering a blend of nature and wildlife close to the road."
  }
],



"services": [
  {
    "name": "Mumbai to Khandala Cab",
    "description": "Deva Cabs offers dependable Mumbai to Khandala cab services for individuals, families, and corporate groups looking to escape to this scenic hill station. Whether it’s a quick weekend retreat or a relaxed sightseeing trip, our range of vehicles ensures comfort, safety, and convenience. Let our trained chauffeurs navigate the expressway while you enjoy a relaxing ride surrounded by lush greenery and hills."
  },
  {
    "name": "One-way cab Mumbai to Khandala",
    "description": "Choose our one-way cab service from Mumbai to Khandala for a simple and budget-friendly travel solution. Ideal for solo travelers, couples, or those staying in Khandala longer, our one-way rides provide a direct, non-stop journey with no return obligation. Travel comfortably with zero hidden charges and on-time pickups guaranteed."
  },
  {
    "name": "Mumbai to Khandala taxi booking",
    "description": "Book your taxi from Mumbai to Khandala effortlessly with Deva Cabs. Our booking process is streamlined for ease — select your vehicle, confirm your details, and you're all set. We offer competitive pricing, prompt service, and clean, well-maintained vehicles to make your travel pleasant and stress-free."
  },
  {
    "name": "AC cab Mumbai to Khandala",
    "description": "Travel in comfort no matter the weather with Deva Cabs’ fully air-conditioned vehicles. Our AC cabs from Mumbai to Khandala ensure you stay cool and relaxed throughout the 1.5–2 hour journey. Great for families, groups, or business travelers looking for a refreshing ride up to the hill station."
  },
  {
    "name": "SUV taxi Mumbai to Khandala",
    "description": "For those needing extra space and power, Deva Cabs provides SUV taxis from Mumbai to Khandala. Ideal for group outings, families with luggage, or travelers preferring a taller ride, our SUVs feature spacious seating, smooth suspension, and skilled drivers familiar with hilly terrain."
  },
  {
    "name": "Chauffeur-driven cab Mumbai to Khandala",
    "description": "Sit back and relax while our experienced chauffeurs handle your trip to Khandala. Deva Cabs’ chauffeur-driven services focus on punctuality, professionalism, and passenger comfort. Our drivers are courteous, well-trained, and knowledgeable about the best routes to ensure a safe, smooth ride."
  },
  {
    "name": "Round trip cab Mumbai to Khandala",
    "description": "Planning a short trip to Khandala and back the same day or next? Deva Cabs offers round trip cab services with flexible return timing, making your visit completely hassle-free. Enjoy scenic views and peaceful moments in Khandala while we manage the driving, parking, and logistics."
  },
  {
    "name": "Mumbai to Khandala sightseeing cab",
    "description": "Explore Khandala’s top attractions like Rajmachi Point, Duke’s Nose, or the misty waterfalls with our sightseeing cab services. Our local drivers help you cover the must-visit spots comfortably, while you relax and enjoy the natural beauty without worrying about transport schedules or navigation."
  },
  {
    "name": "Luxury cab Mumbai to Khandala",
    "description": "Upgrade your ride to Khandala with our luxury cab options. Whether you're celebrating a special occasion or just prefer extra comfort, Deva Cabs offers premium vehicles with plush interiors, smooth rides, and top-tier features for an elevated travel experience."
  },
  {
    "name": "Affordable Khandala cab from Mumbai",
    "description": "Deva Cabs brings you the perfect mix of quality and affordability. Our low-cost cab options from Mumbai to Khandala come with no hidden charges and clean, comfortable cars. Choose from sedans, hatchbacks, or budget SUVs for a reliable ride that suits your wallet."
  },
  {
    "name": "Family cab Mumbai to Khandala",
    "description": "Travel with peace of mind using our family-friendly cabs. With extra legroom, safety features, and courteous drivers, Deva Cabs ensures a smooth ride from Mumbai to Khandala for travelers of all ages. Perfect for vacations, reunions, or weekend getaways with kids and elders."
  },
  {
    "name": "Book Khandala cab online",
    "description": "Booking a cab to Khandala from Mumbai has never been easier. Deva Cabs offers an intuitive online platform where you can compare vehicle types, view real-time availability, and confirm your booking in just a few clicks. Instant confirmation and support ensure a seamless process from start to finish."
  },
  {
    "name": "Mumbai to Khandala car hire",
    "description": "Hire a private car with driver from Mumbai to Khandala through Deva Cabs for maximum flexibility and privacy. Whether for business or leisure, our rental service lets you control your schedule while traveling in comfort. Hourly and daily packages available."
  },
  {
    "name": "Mumbai to Khandala weekend cab",
    "description": "Escape the city for a relaxing weekend in the hills with Deva Cabs’ weekend cab packages. Our special offers include round trip travel, fuel, tolls, and customizable stops — all managed by expert drivers who make sure your weekend trip is comfortable and well-timed."
  },
  {
    "name": "Premium taxi Mumbai to Khandala",
    "description": "Enjoy a premium travel experience from Mumbai to Khandala with our top-tier vehicles and attentive service. Perfect for professionals, couples, or high-end travelers, our premium taxis come with features like leather seats, extra legroom, bottled water, and a dedicated chauffeur."
  }
],
"tableData": [
  ["Mumbai to Khandala Cab", "-One-way cab Mumbai to Khandala"],
  ["Mumbai to Khandala taxi booking", "-AC cab Mumbai to Khandala"],
  ["SUV taxi Mumbai to Khandala", "-Chauffeur-driven cab Mumbai to Khandala"],
  ["Round trip cab Mumbai to Khandala", "-Mumbai to Khandala sightseeing cab"],
  ["Luxury cab Mumbai to Khandala", "-Affordable Khandala cab from Mumbai"],
  ["Family cab Mumbai to Khandala", "-Book Khandala cab online"],
  ["Mumbai to Khandala car hire", "-Mumbai to Khandala weekend cab"],
  ["Premium taxi Mumbai to Khandala", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable and On-Time Mumbai to Khandala Cab Service",
    "WhyChoosedescription": "Our Mumbai to Khandala cab service is known for its punctuality and reliability. Whether you're planning a spontaneous weekend getaway or a carefully scheduled day trip, we ensure prompt pickups, consistent communication, and smooth coordination from start to finish. Our drivers arrive on time, follow well-planned routes, and help you avoid unnecessary delays, giving you a stress-free start to your mountain escape."
  },
  {
    "WhyChooseheading": "Comfortable, Clean, and Spacious Vehicles",
    "WhyChoosedescription": "Your comfort is our priority, especially on long drives through hilly terrain. Our cabs are well-maintained, air-conditioned, and equipped with ergonomic seating and ample legroom. We offer a range of vehicle types—from sedans to SUVs—to suit solo travelers, couples, families, and small groups. Enjoy a relaxed ride through the scenic Western Ghats with a vehicle that makes the journey just as enjoyable as the destination."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Route Expertise",
    "WhyChoosedescription": "Our drivers are seasoned professionals familiar with the Mumbai–Khandala route, including traffic-prone areas, expressway exits, and scenic detours. They drive responsibly, prioritize your safety, and are courteous throughout the trip. Want to stop at a viewpoint or grab a quick snack en route? Our drivers are flexible and helpful, making your journey more personalized and enjoyable."
  },
  {
    "WhyChooseheading": "Fair and Transparent Pricing – No Hidden Charges",
    "WhyChoosedescription": "With our Mumbai to Khandala cab service, what you see is exactly what you pay. We provide a clear, upfront price that includes fuel, tolls, and driver charges—no hidden fees or surprise extras. Our competitive pricing gives you the best value for a premium outstation experience, allowing you to budget confidently and enjoy your trip without any billing worries."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
    "WhyChoosedescription": "Khandala is a popular destination for all kinds of travelers, and we understand that plans can happen anytime. That’s why our cabs are available 24/7—early mornings, late nights, weekends, and holidays included. Whether you're catching sunrise at Tiger’s Leap or heading back late from a picnic, our service is always ready when you are."
  },
  {
    "WhyChooseheading": "Quick and Easy Booking Experience",
    "WhyChoosedescription": "Booking your Mumbai to Khandala cab is simple and convenient. Just use our online platform or call our customer support for instant reservations. You’ll receive booking confirmation, driver contact details, and ride tracking—all designed to keep your experience smooth, efficient, and worry-free from the moment you book until you arrive."
  },
  {
    "WhyChooseheading": "Safe and Secure Travel with Regularly Serviced Vehicles",
    "WhyChoosedescription": "We take your safety seriously. All our cabs undergo regular servicing and safety checks to ensure a secure ride. Each vehicle is equipped with GPS, seat belts, air conditioning, and emergency kits. Our drivers follow strict safety protocols and road rules to give you peace of mind while enjoying the winding roads and lush green landscapes."
  },
  {
    "WhyChooseheading": "Customized Travel Experience to Match Your Plans",
    "WhyChoosedescription": "Every journey is unique, and we’re here to make yours seamless. Need a round trip? Multiple pick-up points? Or extra luggage space for a weekend stay? We offer flexible packages and customizable options to suit your exact requirements. Whether you're visiting for adventure, relaxation, or romance—our cab service adapts to your itinerary with ease."
  }
]





















    }









const faqData = [
  {
    question: "Can I book a cab from Mumbai to Khandala with Deva Cabs?",
    answer: "Yes, Deva Cabs provides reliable and comfortable cab services from Mumbai to Khandala for all travel purposes."
  },
  {
    question: "How long does it take to travel from Mumbai to Khandala by cab?",
    answer: "The journey typically takes around 2.5 to 3 hours depending on traffic and weather conditions."
  },
  {
    question: "What types of vehicles are available for the Mumbai to Khandala route?",
    answer: "We offer a range of vehicles including sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers for families and groups."
  },
  {
    question: "Can I pre-book a cab from Mumbai to Khandala?",
    answer: "Yes, you can pre-book your cab easily through our website, app, or by contacting our support team."
  },
  {
    question: "Are one-way cab services available from Mumbai to Khandala?",
    answer: "Yes, Deva Cabs offers one-way services without the need to pay for the return trip."
  },
  {
    question: "Are tolls and parking charges included in the fare?",
    answer: "Toll and parking charges are usually additional and will be transparently shared during booking."
  },
  {
    question: "Is your service available early morning or late at night?",
    answer: "Yes, Deva Cabs operates 24/7, so you can travel to Khandala at any time from Mumbai."
  },
  {
    question: "Is the journey from Mumbai to Khandala safe by cab?",
    answer: "Absolutely. All our drivers are background-verified and trained for passenger safety and comfort."
  },
  {
    question: "Can I book a round trip to Khandala with a return to Mumbai?",
    answer: "Yes, we offer flexible round trip packages for same-day or extended return journeys."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Khandala cab services?",
    answer: "We provide clean vehicles, experienced drivers, timely service, and competitive pricing for a stress-free experience."
  }
];

const testimonialData = [
  {
    id: 31,
    name: 'Mr. Arvind Nair',
    role: 'Corporate Traveler',
    review: 'I booked a cab from Mumbai to Khandala for a quick getaway. The car was neat and the driver was very professional. Great experience with Deva Cabs!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 32,
    name: 'Ms. Swati Bhave',
    role: 'Weekend Traveler',
    review: 'Deva Cabs made our trip to Khandala super comfortable. Clean vehicle, courteous driver, and smooth booking. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];





































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Khandala Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-khandala-cab.jpg", // Replace with actual image URL
  "description": "Book affordable and reliable Mumbai to Khandala cab service with Deva Cabs. Choose from AC, SUV, luxury, and chauffeur-driven cabs for one-way, round trip, sightseeing, family trips, and weekend rides with easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1150"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3900",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-khandala-cab" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Khandala Cab | Affordable & Luxury Taxi Service | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Khandala cab with Deva Cabs. AC, SUV, luxury, and chauffeur-driven cabs available for one-way, round trip, sightseeing, family trips, and weekend rides. Easy online booking." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Khandala Cab, One-way cab Mumbai to Khandala, Mumbai to Khandala taxi booking, AC cab Mumbai to Khandala, SUV taxi Mumbai to Khandala, Chauffeur-driven cab Mumbai to Khandala, Round trip cab Mumbai to Khandala, Mumbai to Khandala sightseeing cab, Luxury cab Mumbai to Khandala, Affordable Khandala cab from Mumbai, Family cab Mumbai to Khandala, Book Khandala cab online, Mumbai to Khandala car hire, Mumbai to Khandala weekend cab, Premium taxi Mumbai to Khandala" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/24.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitokhandalacab;